import { mediaItems } from '@/mocks/home';

export default function Media() {
  return (
    <section id="media" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">吃瓜视频</h2>
          <p className="text-sm text-foreground-600">热门吃瓜内容视频版，视听双重享受</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item) => (
            <a key={item.id} href="#media" className="group bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/70 transition-colors cursor-pointer">
              <div className="relative overflow-hidden aspect-[16/9]">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-white/90 group-hover:bg-primary-500 group-hover:text-white transition-all shadow-lg">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 text-xs bg-black/70 text-white rounded whitespace-nowrap">
                  {item.duration}
                </span>
                <span className="absolute top-3 left-3 px-2 py-0.5 text-xs font-medium bg-accent-500 text-white rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm text-foreground-900 mb-1 line-clamp-2">{item.title}</h3>
                <span className="text-xs text-foreground-500 flex items-center gap-1">
                  <i className="ri-eye-line"></i> {item.views} 次播放
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}